export const CELL_PADDING_HORIZONTAL = 8;
export const CELL_PADDING_VERTICAL = 6;
export const CELL_PADDING_HEADER = `${CELL_PADDING_HORIZONTAL}px ${CELL_PADDING_HORIZONTAL}px ${CELL_PADDING_VERTICAL}px ${CELL_PADDING_HORIZONTAL}px`;
export const DEFAULT_COL_WIDTH = 200;
export const COLUMN_WIDTH = {
  title: 300,
  description: 350,
  reference: 200,
  // title of a related entity, e.g. a stream or index set
  tags: 200,
  // list of badges, e.g. tags or categories
  user: 150,
  date: 160,
  relativeTime: 140
  // e.g. "a few seconds ago"
};
export const MORE_ACTIONS_TITLE = "More";
export const MORE_ACTIONS_HOVER_TITLE = "More actions";
export const BULK_SELECT_COLUMN_WIDTH = 15 + CELL_PADDING_HORIZONTAL * 2;
export const BULK_SELECT_COL_ID = "bulk-select";
export const ROW_EXPAND_COLUMN_WIDTH = 22 + CELL_PADDING_HORIZONTAL * 2;
export const ROW_EXPAND_COL_ID = "row-expand";
export const ACTIONS_COL_ID = "actions";
export const RESIZE_HIT_AREA_OVERHANG = 7;
export const UTILITY_COLUMNS = /* @__PURE__ */ new Set([ROW_EXPAND_COL_ID, BULK_SELECT_COL_ID, ACTIONS_COL_ID]);
export const ATTRIBUTE_STATUS = {
  show: "show",
  hide: "hide"
};
export const TABLE_LAYOUT_DEFAULT_FILTERS_KEY_SPLITTER = ":";
